<template>
  <div>
    <nav class="navbar is-fixed-top box-shadow-y" :shadow="true">
      <div class="navbar-brand has-text-centered">
        <a href="#" class="navbar-item has-text-weight-bold has-text-black ">ENCUESTA-BIENESTAR</a>
      </div>
      
    </nav>
    <nav class="navbar is-fixed-top box-shadow-y  has-background-primary">
      <div class="navbar-brand">
  
        <a href="#" class="navbar-item has-text-weight-bold has-text-white  has-background-primary">ENCUESTA-BIENESTAR</a>
         <button class="is-hidden-tablet is-hidden-desktop button is-danger is-small" style="margin-top:3%;margin-left:11%"  @click="closeSession()">Cerrar Sesión</button>
      </div>
      <div class="navbar-menu has-background-primary">
        <div class="navbar-start">
        
          
        </div>
        <div class="navbar-end">
     
          <div class="navbar-item has-dropdown is-hoverable has-text-black">
            <a href="#" class="navbar-link has-text-white" >
              <i class="fa fa-user icon has-text-white"></i> 

              {{ email.rut }}
            </a>
            <div class="navbar-dropdown is-right" >
             
              <a class="navbar-item"  @click="closeSession()">Cerrar sesión</a>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div>
     
      <div class="columns is-variable is-0">
        <div>
          <div class="menu-container px-1 has-background-dark">
            <div class="menu-wrapper py-1">
              <aside class="menu">
                <side-menu-administrative v-if="profile == 'administrative'"></side-menu-administrative>
                <SideMenuFunctionary v-if="profile == 'functionary'"></SideMenuFunctionary>
                <!-- <side-menu-collector v-if="profile == 'collector'"></side-menu-collector>
                <side-menu-laboratory v-if="profile == 'laboratory'"></side-menu-laboratory>
                <side-menu-notificator v-if="profile == 'notificator'"></side-menu-notificator>
                <side-menu-assistant v-if="profile == 'assistant'"></side-menu-assistant>
                <side-menu-manager v-if="profile == 'manager'"></side-menu-manager>
                <side-menu-consult-medic v-if="profile == 'consult_medic'"></side-menu-consult-medic> -->
                <p class="menu-label has-text-light has-text-centered" style="background-color:#1a2226;">Acciones</p>
                <ul class="menu-list">

                  <li>
                    <a class="has-text-white" @click="closeSession()">
                      <i class="fas fa-info-circle icon"></i>
                      Cerrar sesión
                    </a>
                  </li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div>
         <EditProfile
          v-if="isComponentEditActive"
          :isComponentEditActive="isComponentEditActive"
          :closeEdit="closeEdit"
          :nameUserConnect="nameUserConnect"
          :user_id="user_id"
        ></EditProfile>
           <changePass
          v-if="isComponentPassActive"
          :isComponentPassActive="isComponentPassActive"
          :closeEditPassword="closeEditPassword"
          :user_id="user_id"
        ></changePass>
        <div class="column is-10-desktop is-offset-2-desktop is-9-tablet is-offset-3-tablet is-12-mobile" >
          <div class="p-1">
            <div class="columns is-variable is-desktop">
              <div class="column">
                <br><br>
                <h1 class="title">
                  <slot name="titulo"></slot>
                </h1>
                        
              </div>

            </div>
                    <slot name="breadCrumb"></slot>

                <br>
        
          
            <div class="columns is-variable">
              <div class="column is-12-desktop is-12-tablet">
                <div class="card">
       
                  <div class="card-content">
                    <div class="media">
                      <div class="media-left">
                        <figure class="image is-96x96">
                          <img src="\images\icono.png">
                        </figure>
                      </div>
                      <div class="media-content">
                        <p class="title is-4">{{userName}}</p>
                        <p class="subtitle is-6">{{email.email}}</p>
                        <p class="subtitle is-8">{{stablishment}}</p>
                      </div>
                    </div>
          
                    <div class="content">
             
                      <div class="field is-grouped">
                        <div class="control">
                          <button class="button is-small is-primary" @click="openEdit(email.id)"> <b-icon pack="fas" icon="user"></b-icon>
                            <span>Editar Perfil</span></button>
                        </div>
                        <div class="control">
                          <button class="button is-small is-dark"  @click="openPass(email.id)"> <b-icon pack="fas" icon="key"></b-icon>
                            <span>Cambiar Contraseña</span></button>
                        </div>
                      </div>
                      <time datetime="2016-1-1">{{fecha}}</time>
                    </div>
                  </div>
                </div>
              <br>
                <slot name="contenido"></slot>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReLogin from "./../components/ReLogin";
import EditProfile from "../components/EditProfile";
import changePass from "../components/changePass";
import SideMenuAdministrative from "./../views/administrative/SideMenu";
import SideMenuFunctionary from "./../views/functionary/SideMenu";
// import SideMenuSupervisor from "./../views/supervisor/SideMenu";
// import SideMenuLaboratory from "./../views/laboratory/SideMenu";
// import SideMenuNotificator from "./../views/notificator/SideMenu";
// import SideMenuAssistant from "@/views/assistant/SideMenu";
// import SideMenuManager from "@/views/manager/SideMenu";
// import SideMenuConsultMedic from "@/views/consultant/SideMenu";

import { eventBus } from "../main";

export default {
  name: "PlantillaContenido",
  components: {
    EditProfile: EditProfile,
    changePass:changePass,
    SideMenuAdministrative,
    SideMenuFunctionary,
    // SideMenuCollector,
    // SideMenuSupervisor,
    // SideMenuLaboratory,
    // SideMenuNotificator,
    // SideMenuAssistant,
    // SideMenuManager,
    // SideMenuConsultMedic
  },
  data() {
    return {
      open: false,
      overlay: true,
      fullheight: true,
      fullwidth: false,
      right: false,
      profile: "",
      detectedError: null,
      userName: "Cargando ...",
      email:'',
      fecha:'',
      isModalReloginShown: false,
      isComponentEditActive: false,
      user_id:'',
      isComponentPassActive: false,
      stablishment:''

    };
  },
  computed: {
    showModal: function () {
      let val;
      eventBus.$on("value", function (value) {
        val = value;
      });
      return val;
    },
    
  },
  mounted() {
    eventBus.$on("value", () => {
      if (!this.isModalReloginShown) {
        this.$buefy.modal.open({
          parent: this,
          component: ReLogin,
          hasModalCard: true,
          trapFocus: true,
          canCancel: false
        });
        this.isModalReloginShown = true;
      }
    });
    this.profile = window.localStorage.getItem("perfil");
  },
  created: function () {
    this.nameUserConnect();
  },
  methods: {
    openMenu: function () {
      this.open = true;
    },
    closeSession: function () {
      this.$buefy.dialog.confirm({
        title: '¿Está seguro que desea cerrar sesión?',
        message: 'Para continuar presione en cerrar sesión.',
        confirmText: 'Cerrar sesión',
        cancelText: 'Cancelar',
        type: 'is-primary',
        hasIcon: true,
        onConfirm:  () => {
          window.localStorage.removeItem("token")
          window.localStorage.removeItem("user")
          window.localStorage.removeItem("userName")
          this.$router.push("/")
        } 
      })
    },
    closeEdit() {
      this.user_id = null;
      this.isComponentEditActive = false;
    },
       closeEditPassword(){
       this.isComponentPassActive=false;
    },
    
    nameUserConnect: function () {
      var mes= ['Enero','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
      var inicio = new Date();
      this.fecha=inicio.getDate() + " de " + ( mes[inicio.getMonth() +1]) + " del " + inicio.getFullYear()
      this.userName = window.localStorage.getItem("userName");
      this.email =JSON.parse(window.localStorage.getItem("user"))
    },
    openEdit:function(id) {
      this.user_id = id,
      this.isComponentEditActive= true
    },
    openPass:function(id) {
      this.user_id = id,
      this.isComponentPassActive= true
    },
  },
};
</script>


<style >
html,
body {
  height: 100%;
  background-color: #efefef;
}

.px-1,
.p-1 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1,
.p-1 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.box-shadow-y {
  -webkit-box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.05);
}

.menu-container {
  position: fixed;
  bottom: 0;
  top: 50px;
  margin: auto;
  min-width: 300px;
  z-index: 10;
  background-color: transparent;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
}

.menu-container.active {
  -webkit-transform: translateX(0%);
  transform: translateX(0%);
}

.icon {
  height: 30px;
  width: 30px;
  vertical-align: baseline;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.toggler {
  margin-left: 0;
  cursor: pointer;
}

@media (min-width: 769px) {
  .menu-container {
    width: 25%;
    min-width: auto;
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
  }
}

@media (min-width: 1024px) {
  .menu-container {
    width: 16.6667%;
    min-width: auto;
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
  }
}

/*# sourceMappingURL=style.css.map */
</style>
<style lang="scss">
  @import "~bulma/sass/utilities/_all";
  @import "~vue-wysiwyg/dist/vueWysiwyg.css";
  
  $my-primary: #2196f3;
  $link: #2196f3;
  $primary-invert: white;
  $pagination-focus-border-color:$my-primary;
  $pagination-current-background-color: $my-primary;
  $menu-item-hover-background-color:#1D292E;
  $navbar-dropdown-arrow:white;
  $menu-label-spacing:1.2em;
  $menu-label-font-size:0.8em;
  $navbar-item-hover-color:black;
  $navbar-item-hover-background-color:black;
  $menu-item-active-background-color:#10171A;
  $datepicker-item-selected-background-color: $my-primary;
  $checkbox-active-background-color: $my-primary;
  $colors: (
    "primary": ($my-primary, $primary-invert),
    "dark":(#222d32, white),
    "success":(#2196f3,white),
    "danger":(#dd4b39,white),
    "warning":(#f39c12,white),
    "light": ($light, $light-invert)
  );

  // Import Bulma and Buefy styles

  @import "~bulma"; 
  @import "~buefy/src/scss/buefy";

</style>